import React, { useState } from "react";

const IN = "w-full min-h-[44px] rounded border border-erf-borderCream px-3 py-2 bg-white text-sm";
const msg = (e) => e?.response?.data?.detail?.message || "Could not send.";

// Message box with @mention chips: the people picked are sent as explicit user ids (validated server-side).
export default function MentionComposer({ team, onSend, withTitle = false, testPrefix }) {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [mentions, setMentions] = useState([]);
  const [err, setErr] = useState("");
  const toggle = (u) => {
    const on = mentions.includes(u.id);
    setMentions(on ? mentions.filter((x) => x !== u.id) : [...mentions, u.id]);
    if (!on && !body.includes(`@${u.name}`)) setBody(`${body}${body && !body.endsWith(" ") ? " " : ""}@${u.name} `);
  };
  const submit = (e) => {
    e.preventDefault();
    onSend({ ...(withTitle ? { title } : {}), body, mentions }).then(() => { setTitle(""); setBody(""); setMentions([]); setErr(""); }).catch((x) => setErr(msg(x)));
  };
  return (
    <form onSubmit={submit} className="space-y-2" data-testid={`${testPrefix}-form`}>
      {withTitle && <label className="text-xs block">Topic<input className={IN} value={title} onChange={(e) => setTitle(e.target.value)} data-testid={`${testPrefix}-title`} /></label>}
      <label className="text-xs block">Message<textarea className={IN} rows={3} value={body} onChange={(e) => setBody(e.target.value)} data-testid={`${testPrefix}-body`} /></label>
      <div className="flex flex-wrap gap-1" aria-label="Mention someone">
        {team.map((u) => (
          <button key={u.id} type="button" aria-pressed={mentions.includes(u.id)} onClick={() => toggle(u)}
            className={`min-h-[44px] px-3 rounded-full border text-xs ${mentions.includes(u.id) ? "bg-erf-dark text-white border-erf-dark" : "border-erf-borderCream bg-white"}`}
            data-testid={`${testPrefix}-mention-${u.id}`}>@{u.name}</button>))}
      </div>
      {err && <p role="alert" className="text-sm text-red-700" data-testid={`${testPrefix}-error`}>{err}</p>}
      <button type="submit" className="min-h-[44px] px-4 rounded-sm text-sm font-semibold bg-erf-dark text-white" data-testid={`${testPrefix}-send`}>{withTitle ? "Start thread" : "Send"}</button>
    </form>
  );
}
